(() => {
  const header = document.querySelector('.header');
  const toggle = document.querySelector('[data-mobile-menu-toggle]');

  if(!header || !toggle) {
    return;
  }

  toggle.addEventListener('click', () => {
    header.classList.toggle('header__mobileMenuActive');
  });

})();